import ListingCard from "@/components/ListingCard";
import PageHeading from "@/components/PageHeading";
import { TeamPage as TeamPageType } from "graphql/generated-types";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { IndexContainer, PillContainer, ListingContainer } from "./IndexContainer";
import { motion, AnimatePresence } from "framer-motion";

const TeamPage = ({ data }: { data: TeamPageType }) => {
	const [people, setPeople] = useState(data.people);

	const locations = data.people?.flatMap((person) => {
		return person?.location?.flatMap((location) => location?.name);
	});
	const uniqueLocations = Array.from(new Set(locations));

	const router = useRouter();
	const locationQuery = router.query.location;

	const handleFilter = (filter: string) => {
		const paths = router.query.urlPaths!;
		let pathArray = paths instanceof Array ? paths : [paths];
		if (filter !== "all") {
			pathArray.push(`?location=${filter}`);
		}
		const path = pathArray.join("/");
		router.push(path, undefined, { shallow: true });
	};

	useEffect(() => {
		if (locationQuery) {
			setPeople(
				data.people?.filter((person) => {
					return person?.location?.some((location) => location?.name === locationQuery);
				}),
			);
		} else {
			setPeople(data.people);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [locationQuery]);

	return (
		<IndexContainer>
			<PageHeading title={data.title} />
			<PillContainer>
				<button className={locationQuery ? "tag-pill" : "tag-pill-reversed"} onClick={() => handleFilter("all")}>
					View all
				</button>
				{uniqueLocations?.map((location, i) => (
					<button
						key={i}
						className={locationQuery === location ? "tag-pill-reversed" : "tag-pill"}
						onClick={() => handleFilter(location!)}
					>
						{location!}
					</button>
				))}
			</PillContainer>
			<ListingContainer>
				<AnimatePresence mode="popLayout">
					{people?.map((person) => {
						return (
							<motion.div
								key={person?.id}
								initial={{ opacity: 0 }}
								animate={{ opacity: 1 }}
								exit={{ opacity: 0 }}
								transition={{ type: "spring" }}
							>
								<ListingCard
									imageSrc={person?.image?.rendition?.url!}
									imageAlt={person?.image?.rendition?.image?.title!}
									title={person?.name!}
									subtitle={person?.title!}
									tags={person?.location?.map((location) => {
										return {
											name: location?.name!,
										};
									})}
									linkHref={person?.linkedin!}
									linkText="LinkedIn"
									teamCard
								/>
							</motion.div>
						);
					})}
				</AnimatePresence>
			</ListingContainer>
		</IndexContainer>
	);
};

export default TeamPage;
